import { Message } from 'primereact/message';
import { useTranslation } from 'react-i18next';

import InfoIconPrimary from '../../../../../../../../assets/icons/InfoIconPrimary';

const GuidanceMessage = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Message
      severity='info'
      className='border-round-2xl bg-primary-100 w-full'
      content={
        <div className='flex flex-row w-full'>
          <div className='mr-2'>
            <InfoIconPrimary width={20} height={20} />
          </div>

          <div className='flex flex-column'>
            <div className='text-lg font-medium mb-2 text-primary'>
              {t('certificateDetailsPage.tabs.permissionsTab.guidanceSection.title')}
            </div>
            <div className='flex flex-column gap-2 text-black-alpha-90'>
              <li>{t('certificateDetailsPage.tabs.permissionsTab.guidanceSection.content')}</li>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default GuidanceMessage;
